import React, { useState, useRef } from 'react';
import { Grid, Typography, IconButton } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { CalendarIcon } from '../../icons';

const labelStyle = {
  marginBottom: '4px',
  fontWeight: 600,
  color: '#1A1A1A',
  fontSize: '14px',
};

const inputStyle = {
  height: '46px',
  backgroundColor: '#fff',
  fontSize: '13px',
  cursor: 'pointer',
  '& .MuiInputBase-input': {
    cursor: 'pointer',
  },
};

const MyDatePicker = () => {
  const [value, setValue] = useState(null);
  const [open, setOpen] = useState(false);
  const inputRef = useRef(null);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Grid item xs={12} md={6}> 
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          value={value}
          open={open}
          onOpen={handleOpen}
          onClose={handleClose}
          onChange={(newValue) => setValue(newValue)}
          slots={{
            openPickerIcon: CalendarIcon,
          }}
          slotProps={{
            textField: {
              fullWidth: true,
              variant: 'outlined',
              placeholder: 'Select Date',
              InputProps: {
                sx: inputStyle,
                readOnly: true,
                endAdornment: (
                  <IconButton
                    edge="end"
                    onClick={handleOpen}
                    sx={{ pointerEvents: 'auto' }}
                  >
                    <CalendarIcon />
                  </IconButton>
                ),
              },
              onClick: handleOpen,
              ref: inputRef,
            },
            popper: {
              placement: 'bottom-start',
            },
            inputAdornment: {
              position: 'end',
            },
            openPickerButton: {
              sx: { display: 'none' }, // Hide the default button
            },
          }}
        />
      </LocalizationProvider>
    </Grid>
  );
};

export default MyDatePicker;